module.exports = __webpack_public_path__ + "img/sergio.0067bd0c.png";